import { PlanTargetType } from '@type';

export const userCategories = [PlanTargetType.ALL, PlanTargetType.INDIVIDUAL];
export const companyCategories = [PlanTargetType.ALL, PlanTargetType.COMPANY];
